import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProfileProvider } from './context/ProfileContext';
import './App.css';
import './style/variables.css';
// Import pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import TailorResume from './pages/TailorResume';

// import Register from './pages/RegisterFlow/Register';

// Import components
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import ResumeHistory from './components/resume/ResumeHistory';

import './pages/common/PageStyles.css';
import HelpCenter from './pages/common/HelpCenter';
import FAQ from './pages/common/FAQ';
import TermsOfService from './pages/common/TermsOfService';
import PrivacyPolicy from './pages/common/PrivacyPolicy';
import ContactUs from './pages/common/ContactUs';
import AboutUs from './pages/common/AboutUs';
import Pricing from './pages/common/Pricing';

// Protected Route component - redirects to login if not authenticated
const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, loading } = useAuth();
  
  // Show loading state while checking authentication
  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }
  
  // Redirect to login if not authenticated
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }
  
  // Render children if authenticated
  return children;
};

// Main App component
const AppContent = () => {
  return (
    <Router>
      <div className="app">
        <Navbar />
        
        <main className="main-content">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/register" element={<Register />} />
            <Route path="/register" element={<Register />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/pricing" element={<Pricing />} />

            
            {/* Protected routes */}
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/tailor" 
              element={
                <ProtectedRoute>
                  <TailorResume />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/history" 
              element={
                <ProtectedRoute>
                  <ResumeHistory />
                </ProtectedRoute>
              } 
            />
            
            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
};

// App with context providers
const App = () => {
  return (
    <AuthProvider>
      <ProfileProvider>
        <AppContent />
      </ProfileProvider>
    </AuthProvider>
  );
};

export default App;